/*
 *   File : manage-faqs.js
 *   Author : https://evoqins.com
 *   Description : Manage faqs of admin modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/


// packages
import React, { useEffect, useState } from 'react';

// custom components
import Icon from '../Icon/icon';
import { CustomSelectBox, CustomTextArea, CustomTextInput } from '../FormElements';
import { PrimaryButton, SecondaryButton } from '../Buttons';


// styles
import Color from '../../Style/color.scss';


const CATEGORY = [
    {
        id: 1,
        label: 'Account',
        value: 'Account',
    },
    {
        id: 2,
        label: 'Payments',
        value: 'Payments',
    },
    {
        id: 3,
        label: ' Portfoio management',
        value: ' Portfoio management'
    },
    {
        id: 4,
        label: 'Privacy and security',
        value: 'Privacy and security'
    }
];

const ManageFaqModal = (props) => {

    const [question, setQuestion] = useState("");
    const [questionError, setQuestionError] = useState("");
    const [answer, setAnswer] = useState("");
    const [answerError, setAnswerError] = useState("");
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [type, setType] = useState(true); // true - Create false - Edit
    const [selectedCategoryError, setSelectedCategoryError] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);


    useEffect(() => {
        if (props.data != undefined) {
            setQuestion(props.data.question);
            setAnswer(props.data.answer);
            setSelectedCategory({ label: props.data.category_text, value: props.data.category_id });
        }
    }, [props.data]);


    useEffect(() => {
        setQuestionError("");
    }, [question]);

    useEffect(() => {
        setSelectedCategoryError("");
    }, [selectedCategory]);


    useEffect(() => {
        setAnswerError("")
    }, [answer]);


    const _handleCreateOrEdit = () => {

        let is_valid = true;

        if (question.trim().length === 0) {
            setQuestionError("Question is required");
            is_valid = false;
        }

        if (selectedCategory === null) {
            setSelectedCategoryError('Please select category');
            is_valid = false;
        }

        if (answer.trim().length === 0) {
            setAnswerError("Answer is required");
            is_valid = false;
        }

    };

    const _handleCloseModal = () => {
        var button = document.getElementById("manage-faq-modal-close");
        button.click();
        props.handleClose();
    };



    return (

        <div className="modal fade"
            id="manage-faq-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="manageFaqModalLabel"
            aria-hidden="true">

            <div className={`modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28`}>
                <span id='manage-faq-modal-close'
                    className='d-none'
                    data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {props.data !== null ? "Edit FAQ" : "Add FAQ"}
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            data-bs-dismiss="modal"
                            onClick={_handleCloseModal}
                            className="d-flex cursor-pointer"
                        />
                    </div>

                    {/* Modal body */}
                    <div className={`${menuOpen ? 'overflow-visible' : ''} modal-body pt-0 padding-32px-lr padding-40px-bottom`}>
                        <div className='row pb-3'>
                            {/* Role */}
                            <div className='col-12'>
                                <CustomTextInput label="Question"
                                    placeholder="Enter the Question"
                                    type="text"
                                    autoFocus={true}
                                    required={true}
                                    value={question}
                                    error={questionError}
                                    className="w-100 "
                                    inputType={2}
                                    onKeyPress={_handleCreateOrEdit}
                                    handleChange={(e) => setQuestion(e)} />


                                <div className='mt-3'>
                                    <CustomTextArea label="Answer"
                                        placeholder="Enter the Answer"
                                        type="text"
                                        required={true}
                                        rows={4}
                                        error={answerError}
                                        value={answer}
                                        handleChange={(e) => setAnswer(e)} />
                                </div>
                            </div>
                        </div>


                        <div className='col-6'>
                            {/* Category */}
                            <CustomSelectBox title='Category'
                                placeholder='Select category'
                                controlWidth='w-100'
                                required={true}
                                options={CATEGORY}
                                isSearchable={true}
                                isMulti={false}
                                menuIsOpen={menuOpen}
                                onMenuOpen={() => setMenuOpen(true)}
                                onMenuClose={() => setMenuOpen(false)}
                                borderColor={`0.031rem solid ${Color.arsenic}`}
                                padding="0.5rem 1rem"
                                value={selectedCategory}
                                error={selectedCategoryError}
                                onChange={(e) => setSelectedCategory(e)} />
                        </div>
                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-4'>
                        <SecondaryButton name="Cancel"
                            className="py-3 padding-54px-lr"
                            // dismiss="modal"
                            onClick={_handleCloseModal}
                        />
                        <PrimaryButton name={props.data !== null ? "Update FAQ" : "Add FAQ"}
                            paddingBlock="padding-16px-tb padding-52px-lr"
                            onClick={_handleCreateOrEdit} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageFaqModal;



ManageFaqModal.defaultProps = {
    handleClose: () => { }

};


